import template from './filter-bar.html';
import controller from './filter-bar-controller';

const FilterBarComponent = {
    bindings: {
        clientList: '<',
        isCommitted: '<',
        isMerFacility: '<',
        onFilterChange: '&',
        onFormSelect: '&'
    },
    controller,
    template
};

export default FilterBarComponent;



// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/filter-bar/filter-bar-component.js